import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError, Button } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndChargePayGate } from 'redux/cart/actions';

import PayGateHiddenForm from './PayGateHiddenForm';
import {
  validateAddressForNotLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      redirect: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    this.setState({ isSubmitting: true });
    const data = transformData(form);
    const cart = props.cart.data;
    const successFunction = (order) => {
      this.setState({ isSubmitting: false });
      props.history.push(
        `/checkout/receipt?orderNumber=${
          order.orderNumber
        }&email=${encodeURIComponent(cart.email)}`
      );
    };
    const redirectFunction = (response) => {
      this.setState({ redirect: response });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    props.updateAndChargePayGate(
      data.address,
      data.creditCard,
      0,
      successFunction,
      redirectFunction,
      errorFunction
    );
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  render() {
    const { cart, handleSubmit, change, form, settings } = this.props;
    const { isSubmitting, redirect } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (cart.billTo) {
      object = cart.billTo;
    }
    if (redirect) {
      return <PayGateHiddenForm redirect={redirect} />;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardForm />

        <p>&nbsp;</p>
        <h3>Billing address</h3>
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />

        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label="Return to cutomer information"
            onClick={this.handleBack}
          >
            Return to customer information
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  const creditCard = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName
  };
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  const { address } = transformData(values);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForNotLoggedInCustomer(address, props.settings)
  );
  const { creditCard } = transformData(values);
  errors = Object.assign(errors, validateCreditCard(creditCard));
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues = {};
  if (state.cart && state.cart.data) {
    const { billTo } = state.cart.data;
    initialValues = Object.assign(initialValues, initialFormValues(billTo));
    if (!initialValues.countryCode) {
      initialValues.countryCode = getDefaultCountryCode(state.setting);
    }
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    initialValues
  };
};

Payment = reduxForm({
  form: 'paymentNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, { updateAndChargePayGate })(Payment)
);
